<script setup lang="ts">
const store = useCalculationCPTStore()

const { selectedItems, exportExcelDialog, exportExcelLoading } = storeToRefs(store)

const selectedCalculationCPT = computed(() => {
  return selectedItems.value.length === 1 ? selectedItems.value[0] : null
})

async function exportExcel() {
  await store.exportExcel()
  store.toggleExportExcelDialog(false)
}
</script>
<template>
  <v-dialog
    :model-value="exportExcelDialog"
    @click:outside="store.toggleExportExcelDialog()"
    max-width="600"
  >
    <v-card class="pa-3">
      <v-card-title>Export to excel</v-card-title>
      <v-card-text class="pl-4">
        Do you want to export Calculation CPT
        <strong>{{ selectedCalculationCPT?.location_id }}</strong> result to excel file?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="exportExcelLoading"
          color="primary text-none"
          @click="store.toggleExportExcelDialog()"
        >
          Cancel
        </v-btn>
        <v-btn :loading="exportExcelLoading" color="primary text-none" @click="exportExcel()">
          Export
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
